import { useRef } from 'react';
import { Flex, Group, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';

import type { SubmoduleDef } from '../types/modulesv2';

import CopyIcon from '@/assets/icons/content/copy.svg';

import classes from './IssueModule.module.css';

interface SubmoduleProps<TData> {
  submodule: SubmoduleDef<TData>;
  gap?: number;
  justify?: string;
}

const Submodule = <TData extends unknown>({ submodule, gap = 5 }: SubmoduleProps<TData>) => {
  const clipboard = useClipboard({ timeout: 1000 });
  const moduleContentRef = useRef<HTMLDivElement>(null);

  const {
    accessor,
    element,
    title,
    canCopy,
    canEdit,
    scroll,
    render,
    direction = 'column',
    justify = 'start',
    ...flexProps
  } = submodule;

  const onClickCopy = () => {
    const text = moduleContentRef?.current?.innerText;
    clipboard.copy(String(text));
  };

  return (
    <Flex gap={gap} direction={direction} justify={justify} {...flexProps}>
      {title && (
        <Group justify="space-between" align="center">
          <h3 className={classes.submoduleTitle}>
            <span>{title}</span>
          </h3>

          {canCopy &&
            (clipboard.copied ? (
              <span>copied!</span>
            ) : (
              <Tooltip label="Copy">
                <button type="button" onClick={onClickCopy}>
                  <CopyIcon>Copy</CopyIcon>
                </button>
              </Tooltip>
            ))}
        </Group>
      )}

      <div
        className={`${classes.submoduleContent} ${scroll ? classes.scroll : ''} content`}
        ref={moduleContentRef}
      >
        {render}
      </div>
    </Flex>
  );
};

export default Submodule;
